// Available colors for beneficiary color picker
const BENEFICIARY_COLORS = [
    '#00818F',
    '#16AA49',
    '#074FAF',
    '#B01A7A',
    '#790D9A',
    '#D6D6CF',
    '#384249',
    '#C0C923',
    '#EA635B'
];

export default BENEFICIARY_COLORS;

